export const SET_USER = 'SET_USER'

export const LOGOUT = 'LOGOUT'

export const SET_LOADING = 'SET_LOADING'

export const LOGIN = 'LOGIN'
